<!-- Loading bar -->
<fuse-loading-bar />

@if (!isExtension) {
    <!-- Desktop / Mobile layout with sidenav -->
    <mat-sidenav-container class="flex-auto">

        <!-- Sidebar -->
        <mat-sidenav
            class="dark w-72 bg-gray-900"
            [mode]="isScreenSmall() ? 'over' : 'side'"
            [opened]="navigationOpened()"
            (openedChange)="navigationOpened.set($event)"
            fixedInViewport
            #sidenav="matSidenav"
        >
            <!-- Logo -->
            <div class="flex h-20 items-center p-6 pb-0">
                <img class="w-30 flex" src="images/logo/logo-text-on-dark.svg" alt="Logo" />
            </div>

            <!-- Navigation -->
            <fuse-vertical-navigation
                [inner]="true"
                [navigation]="navigation()?.default ?? []"
            />

            <!-- Spacer -->
            <div class="flex-auto"></div>

            <!-- Footer -->
            @if (isFreeLicense()) {
                <div class="flex flex-col items-center justify-center p-6 pt-0 ">
                    <a
                        href="https://www.ailotse.com/preise"
                        target="_blank"
                        class="inline-flex items-center rounded-md border border-gray-600 bg-gray-700 px-3 py-1.5 text-sm font-medium text-gray-100 transition-colors duration-200 hover:border-gray-500 hover:bg-gray-600 hover:text-white">
                        <mat-icon svgIcon="mat_outline:auto_awesome" class="mr-1.5 h-3.5 w-3.5" />
                        Upgrade durchführen
                    </a>
                </div>
            } @else {
                <div class="p-6 pt-0 ">
                    <app-test-phase-info />
                </div>
            }
        </mat-sidenav>

        <!-- Main content -->
        <mat-sidenav-content>
            <div class="flex min-h-full flex-auto flex-col">
                <!-- Header -->
                <div
                    class="bg-card z-49 flex-0 relative flex h-16 w-full items-center px-4 shadow md:px-6">
                    <!-- Navigation toggle button -->
                    <button
                        mat-icon-button
                        type="button"
                        [matTooltip]="navigationOpened() ? 'Navigation einklappen' : 'Navigation ausklappen'"
                        (click)="toggleNavigation()"
                        [attr.aria-label]="navigationOpened() ? 'Navigation einklappen' : 'Navigation ausklappen'">
                        <mat-icon
                            class="transition-transform"
                            [style.transform]="navigationOpened() ? '' : 'scaleX(-1)'"
                            svgIcon="mat_outline:menu_open">
                        </mat-icon>
                    </button>
                    <!-- Search Component -->
                    <div class="mx-4 flex-1">
                        <search></search>
                    </div>
                    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
                        <fuse-fullscreen class="hidden md:block" />
                        <help-menu />
                        <user [isExtension]="isExtension" />
                    </div>
                </div>

                <!-- Content -->
                <div class="flex flex-auto flex-col">
                    <router-outlet />
                </div>

                <!-- Footer -->
                <div
                    class="bg-card z-49 flex-0 relative flex h-14 w-full items-center justify-start border-t px-4 md:px-6">
                    <span class="text-secondary font-medium">AI Lotse &copy; {{ currentYear }}</span>
                </div>
            </div>
        </mat-sidenav-content>

    </mat-sidenav-container>
} @else {
    <!-- Extension mode: no sidebar -->
    <div class="flex w-full min-w-0 flex-auto flex-col">
        <!-- Header (simplified) -->
        <div
            class="bg-card z-49 flex-0 relative flex h-16 w-full items-center px-4 shadow md:px-6">
            <div class="flex-1">
                <search [copyOnSelect]="true"></search>
            </div>
            <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
                <help-menu />
                <user [isExtension]="isExtension" />
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-auto flex-col">
            <router-outlet />
        </div>
    </div>
}
